// extracted by mini-css-extract-plugin
export default {"checklist":"checklist_checklist__Opdz9"};